import { render, staticRenderFns } from "./TableSubjects.vue?vue&type=template&id=388e87f0&"
import script from "./TableSubjects.vue?vue&type=script&lang=js&"
export * from "./TableSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388e87f0')) {
      api.createRecord('388e87f0', component.options)
    } else {
      api.reload('388e87f0', component.options)
    }
    module.hot.accept("./TableSubjects.vue?vue&type=template&id=388e87f0&", function () {
      api.rerender('388e87f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/subjects/TableSubjects.vue"
export default component.exports